<div class="loginbox">
  <div class="tabs">
    <label class="title">{{"shopify.login.FulfillmentBridge" | translate:{companyName:currentCompany.name} }}</label>

    <div class="tab">
      <input name="checkbox-tabs-group" type="radio" id="checkbox2" class="checkboxtab">
      <label>
        <a href="https://fulfillmentbridge.com/" target="_blank" style="color: #fff; text-decoration: none;">
          {{"shopify.login.back" | translate }}</a>
      </label>
    </div>

    <div class="tab">
      <input name="checkbox-tabs-group" type="radio" id="checkbox2" class="checkboxtab">
      <label [routerLink]="['/shopifyregister/',currentShop,currentToken] ">
        {{"shopify.login.register" | translate }}</label>
    </div>

    <div class="tab">
      <input name="checkbox-tabs-group" type="radio" id="checkbox3" class="checkboxtab">
      <label for="checkbox3">
        {{"shopify.login.labellogin" | translate }}</label>
      <div class="content">
        <div class="row col-md-12 col-xs-12" style="display: inline-block;">
          <div class="col-md-6 col-xs-12" style="float: left;">
            <img class="finger" src="../assets/images/logoApp.png">
          </div>
          <div class="col-md-6 col-xs-12" style="float: left;">
            <h4 class="login-title">
              {{"shopify.login.loginefb" | translate }}</h4>
            <div class="ui form langage-login">
              <div class="field">
                <select 
                      id="languageSelect"
                      [value]="currentLanguage" 
                      (change)="changeLanguage($event.target.value)"
                      class="ui dropdown">
                      <option 
                        *ngFor="let lang of getAvailableLanguages()" 
                        [value]="lang.code"
                        [selected]="lang.code === currentLanguage">
                        {{ lang.name }}
                      </option>
                    </select>
              </div>
            </div>
            <form class="ui form" (ngSubmit)="login()" style="text-align: center; margin-top: 20px;">
              <div class="alert alert-danger alert-sm" *ngIf="error">
                <span class="fw-semi-bold">{{'shopify.login.login.error' | translate }}</span>.
              </div>
              <div class="field">
                <input type="text" [(ngModel)]="cred.username" name="first-name"
                  placeholder="{{'shopify.login.placeholder.username' | translate }}">
              </div>
              <div class="field">
                <input type="password" [(ngModel)]="cred.password" name="last-name"
                  placeholder="{{'shopify.login.placeholder.password' | translate }}">
              </div>
              <div class="field">
              </div>
              <button class="ui button primary" type="submit">{{'shopify.login.loginbtn' | translate }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>